module.exports = __webpack_public_path__ + "img/banner1.62a12099.png";